<!-- component for showing pet owner details on right bar -->
<template>
  <div class="p2">
    <dl class="px1 m0 h5">
      <dt v-if="chat.owner">Valtuutetun hoitajan nimi</dt>
      <dt v-else>Nimi</dt>
      <dd>{{chat.userName}}</dd>

      <dt>Puhelinnumero</dt>
      <dd>{{chat.phonenumber}}</dd>

      <dt>Sähköposti</dt>
      <dd>{{chat.email}}</dd>

      <dt>Osoite</dt>
      <dd>{{chat.address}}</dd>

    </dl>
    <dl v-if="chat.owner" class="px1 m0 h5">
      <dt>Vakuutuksenottajan nimi</dt>
      <dd>{{chat.owner.firstName}} {{chat.owner.lastName}}</dd>

      <dt>Puhelinnumero</dt>
      <dd>{{chat.owner.phoneNumber}}</dd>

      <dt>Sähköposti</dt>
      <dd>{{chat.owner.email}}</dd>

      <dt>Osoite</dt>
      <dd>{{chat.owner.addressStr}}</dd>
    </dl>
  </div>
</template>

<script>
export default {
    name: 'PetDetails',
    props: {
      chat: Object,
    },
};
</script>

<style scoped>
</style>
